import { Text } from "@react-pdf/renderer";
import { useMemo } from "react";

const PdfSectionTitle = ({ children, style }) => {
  const styles = useMemo(() => {
    return {
      fontSize: 12,
      marginBottom: 8,
      // marginBottom: 15,
      fontWeight: "bold",
      color: "#2962ff",
      borderBottom: "2px solid #f5f5f5",
      // backgroundColor: "#f5f5f5",
      paddingBottom: 6,
      // paddingBottom: 3,
      ...style,
    };
  }, [style]);
  return <Text style={styles}>{children}</Text>;
};

export default PdfSectionTitle;
